export const LEAGUE_ORDER = [
  'onboarding',
  'hcp_54',
  'hcp_42',
  'hcp_36',
  'hcp_28',
  'hcp_18',
  'hcp_10',
] as const;

export type League = typeof LEAGUE_ORDER[number];

/** Used ONLY in the onboarding flow (signup handicap shortcut). */
export function getLeagueFromHandicap(handicap: number | null): string {
  if (handicap === null || handicap > 54) return 'onboarding';
  if (handicap > 45) return 'hcp_54';
  if (handicap > 36) return 'hcp_42';
  if (handicap > 28) return 'hcp_36';
  if (handicap > 18) return 'hcp_28';
  if (handicap > 10) return 'hcp_18';
  return 'hcp_10';
}

/**
 * Used everywhere after signup.
 * Walks the league order and returns the first league that isn't 100% complete.
 */
export function getCurrentLeague(
  completedQuestsByLeague: Record<string, number>,
  totalQuestsByLeague: Record<string, number>
): string {
  for (const league of LEAGUE_ORDER) {
    const total = totalQuestsByLeague[league] ?? 0;
    const completed = completedQuestsByLeague[league] ?? 0;
    if (total === 0 || completed < total) return league;
  }
  return 'hcp_10';
}
